module.exports = __webpack_public_path__ + "static/img/btn_line_contact1.2edc291.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/btn_line_contact1.png
// module id = UBo1
// module chunks = 134